import { Component, OnInit, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgForm } from '@angular/forms';
import { IMyDpOptions, IMyInputFieldChanged, IMyDateModel } from 'mydatepicker';
import { Subscription, TimeClockDeviceDetails } from '../Classes/SubscriptionClass';
import { SubscriptionService } from '../Services/SubscriptionService';
import { EntityService } from '../Services/EntityService';
import { Observable } from 'rxjs';
import { forEach } from '@angular/router/src/utils/collection';
import { saveAs as importedSaveAs } from "file-saver";
import { element } from 'protractor';
import { debug, isNull } from 'util';
import { read } from 'fs';
import { Console } from '@angular/core/src/console';
import { Signatory } from '../Classes/Signatory';
import { StartDateLockReason } from '../Classes/StartDate';
import { SignatoryService } from '../Services/Signatory.service';
import { SubscriptionModule } from '../Classes/CommonClass';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';


@Component({
  selector: 'SubscriptionDetails',
  templateUrl: '../Subscription/SubscriptionDetails.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [EntityService, SubscriptionService, SignatoryService]
})
export class SubscriptionDetails implements OnInit {
  // Code was generated using AI assistance
  SubscriptionModule = SubscriptionModule;
  
  @ViewChild('signatoryForm') sigForm;
  File: File;
  errorMessage: any;
  alertClosed: boolean;
  isSignatoryEditable: boolean = true;
  file: File;
  filesToUpload: File[];
  flImport(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  Attachtext: any = "Attach acceptance document";
  RoleID: string = "";
  QueryOrgcode: any = [];
  AllAccExecutive: any = [];
  SubDetails: any = [];
  DateChange: string = 'New';
  SubscriptionDet: any = {};
  checkdate: string = '';
  fileToUpload: File = null;
  Validate: boolean = true;
  QueryPayrollStartDate: any;
  QuerySDate: any;
  QueryEffDate: any;
  QueryWeeklyDate: any;
  QueryWeeklyLayout: string = '';
  PayperiodDowStartDate: any = '';
  payPeriodStartCheck: any = '';
  oldpayPeriodFrequency: any = '';
  OldData: any = [];
  StartDowPayDate: any = '';
  PayrollExportTypes: any[];
  PayrollDowPayDate: any = '';
  isValidFormSubmitted: boolean = false;
  SubscriptionChangeLog: any = [];
  QueryStartDate: any = [];
  QueryBookingDate: any = [];
  CompareDate: any = '';
  AddTablearray: any = [];
  Payrollarray: any = [];
  FinalArray: any = [];
  PushArray: any = [];
  SubDet: any = [];
  QueryTenantId: string;
  ImportAdd: string = "none";
  ValidForm: boolean = true;
  loading: boolean = false;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  QueryEntityId: string;
  ParentPage: string;
  type: string;
  disable: boolean = true;
  btndisable: boolean = false;
  isSavingSignatory: boolean = false;
  private isStartDateDialogOpen: boolean = false;
  // True once the start-date change has been confirmed (or reverted) for the current
  // Save, so re-entering SaveSuscriptionDetails after the dialog doesn't re-prompt.
  private startDateConfirmed: boolean = false;
  validatesub: boolean = true;
  ModelAddSubscription: string = "none";
  SubscriptionDetailGrid: string = "none";
  querymodule: string = '';
  modelChangeLog: string = "none";
  modelRemovepayroll: string = "none";
  _Subscription = new Subscription();
  _TimeClockDeviceDetails = new TimeClockDeviceDetails();
  //_userdetails = new Userdetails();
  Isdisable: string = 'false';
  _lastSubStatus: string = 'Active'
  isValidSubscription: boolean = false;
  SubsDetStatus: string = 'Active'
  entityStatus: string = 'Active'
  lastDate: any = "";
  //hideSmileID: boolean = false;
  ModelTimeClockDevice: string = "none";
  GetModelTimeClockDevice: any = [];
  //txtuniqueNo: string;
  //txtMachineID: string;
  //txtNote: string;
  //ddlLanguage: string;

  machineNmes: any = [];
  localSubscriptionID: string = "";
  subscriptionServiceData: any[] = [];
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true,
    openSelectorTopOfInput: true,
    editableDateField: false
  };


  public myDatePickerStartdateAutoImport: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '87%',
    //margin-bottom: '4px',
    selectionTxtFontSize: '12px',

    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorTopOfInput: true,
    openSelectorOnInputClick: true
  };


  public myDatePickerStartdateOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mmm yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    editableDateField: false,
    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };

  public myDatePickerTableOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mmm yyyy',
    height: '20px',
    width: '150px',
    selectionTxtFontSize: '12px',
    editableDateField: false,
    inline: false,
    selectorHeight: '150px',
    selectorWidth: '200px',

    openSelectorOnInputClick: true
  };
  constructor(private router: Router, private http: Http, public toastr: ToastsManager, vcr: ViewContainerRef,
    private Activeroute: ActivatedRoute, private _EntityService: EntityService, private _Subscriptions: SubscriptionService, private _signatoryService: SignatoryService,
    private confirmDialogService: ConfirmDialogService) {
    this.toastr.setRootViewContainerRef(vcr);
    window.scrollTo(0, 0);


  }

  ngOnInit() {
    debugger;
    if (this.Activeroute.snapshot.params['TenantID'] != null && this.Activeroute.snapshot.params['EntityID'] != null && this.Activeroute.snapshot.params['Module'] != null) {
      var TenantId = this.Activeroute.snapshot.params['TenantID'];
      var EntityId = this.Activeroute.snapshot.params['EntityID'];
      var Module = this.Activeroute.snapshot.params['Module'];
      this.ParentPage = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
      this._Subscription.TenantId = JSON.parse(atob(TenantId));
      this._Subscription.HotelId = JSON.parse(atob(EntityId));
      this._Subscription.OrganizationCode = JSON.parse(atob(this.Activeroute.snapshot.params['OrganizationCode']));
      this._Subscription.EntityCode = JSON.parse(atob(this.Activeroute.snapshot.params['EntityCode']));
      this.RoleID = sessionStorage.getItem('RoleID');
      this.querymodule = JSON.parse(atob(Module));
      this._Subscription.Module = this.querymodule;
      localStorage.setItem("TenantID", this._Subscription.TenantId.toString());
      localStorage.setItem("HotelId", this._Subscription.HotelId);
      this.getSubscriptionDetails();
      this.type = "Edit";
      this.GetSubscriptionServices();
      //
      if (this._Subscription.Module == "Labor Management") {
        this.SubscriptionDetailGrid = "block";
      }
      this.getalluser();
      this.getalllaborexporttypeformat();
      this.Editdata();
      this.ValidateSubscription();
      this.ValidateDateStartDate();
      // Load existing signatory if available
      if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
        this.LoadSignatory();
      }
      // this.ValidationSubscriptionStartDate();
      this.getMachineIdDetail();
      localStorage.setItem('Module', null);
      localStorage.setItem('OrgCode', this._Subscription.OrganizationCode);

    }
    else {
      var TenantId = this.Activeroute.snapshot.params['TenantID'];
      var EntityId = this.Activeroute.snapshot.params['EntityID'];
      this._Subscription.TenantId = JSON.parse(atob(TenantId));
      this._Subscription.HotelId = JSON.parse(atob(EntityId));
      this._Subscription.OrganizationCode = JSON.parse(atob(this.Activeroute.snapshot.params['OrganizationCode']));
      this._Subscription.EntityCode = JSON.parse(atob(this.Activeroute.snapshot.params['EntityCode']));
      localStorage.setItem("TenantID", this._Subscription.TenantId.toString());
      localStorage.setItem("OrgCode", this._Subscription.OrganizationCode);
      this.RoleID = sessionStorage.getItem('RoleID');
      this.type = "New";
      this._Subscription.Module = '-1';
      this._Subscription.subscriptionType = 'Full';
      this._Subscription.AutoImport = true;
      this._Subscription.Payroll = true;
      this._Subscription.Status = '-1';
      this._Subscription.Trainer = -1;
      this._Subscription.ReasonForTermination = '-1';
      this._Subscription.PayPeriodFrequency = '-1';
      this._Subscription.OvertimeRules = 'Standard';
      //this._Subscription.MaxDailyHours = "8";
      //this._Subscription.MaxWeeklyHours = "40";
      this._Subscription.PayrollExportType = 'IF OTHER 1';
      this._Subscription.ImplementationStatus = '-1';
      //------------Below for Display Date In Calender control-----------
      this._Subscription.BookingDate = '';
      this._Subscription.StartDate = { jsdate: new Date() };
      this._Subscription.DataStartDate = { jsdate: new Date() };
      localStorage.setItem("HotelId", this._Subscription.HotelId);
      this._Subscription.FullsubscriptionStartDate = { jsdate: new Date() };
      // this._Subscription.AutoImportCurrentDate = { jsdate: new Date() };
      this.getalluser();
      this.getalllaborexporttypeformat();
      this.ValidateDateStartDate();
      // this.ValidationSubscriptionStartDate();
      //this.GetSubscriptionchangeLog();
    }

    this.ChangeHeadeFooterColor();
  };


  Setterminationdate() {
    if (this._Subscription.Status == 'Inactive') {
      var date = new Date();
      this._Subscription.TerminationDate = { jsdate: new Date(date.getFullYear(), date.getMonth(), 1) };
    }
    else {
      this._Subscription.TerminationDate = "";
    }
  }

  public RedirectOrganizationPage() {

    if (this.ParentPage == 'Subscription') {
      this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(this._Subscription.TenantId)), pageName: btoa(JSON.stringify('SubscriptionDetails')) }]);
    }
    else {
      this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(this._Subscription.TenantId)), pageName: btoa(JSON.stringify('SubscriptionDetail')) }]);
    }

  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }
  public RedirectEntityPage() {
    if (this.ParentPage == 'Subscription') {
      this.router.navigate(['/CreateEntity', {
        TenantID: btoa(JSON.stringify(this._Subscription.TenantId)),
        EntityID: btoa(JSON.stringify(this._Subscription.HotelId)),
        OrgCode: btoa(JSON.stringify(this._Subscription.OrganizationCode)),
        pageName: btoa(JSON.stringify('SubscriptionDetails'))
      }]);
    }
    else
      this.router.navigate(['/CreateEntity', {
        TenantID: btoa(JSON.stringify(this._Subscription.TenantId)),
        EntityID: btoa(JSON.stringify(this._Subscription.HotelId)),
        OrgCode: btoa(JSON.stringify(this._Subscription.OrganizationCode)),
        pageName: btoa(JSON.stringify('SubscriptionDetail'))
      }]);
  }

  public getSubscriptionDetails() {
    //

    this._Subscriptions.GetEditSubSearchResult(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString(), this._Subscription.Module, 'LIMITED').subscribe(res => {
      this.SubDet = res;
      this.disable = true;
      console.log(res);
      // 
      //this._lastSubStatus = this.SubDet[this.SubDet.length - 1].status;
      this.SubsDetStatus = this.SubDet[this.SubDet.length - 1].status;
      this.lastDate = this.SubDet[this.SubDet.length - 1].startDate;
      for (let i = 0; i <= this.SubDet.length; i++) {
        if (i == this.SubDet.length) {
          //if (this.disable != false) {
          //  this._Subscription.SubDetails.push({ 'status': 'Select', 'startDate': '', 'renewalAmount': '', 'subscriptionType': 'Select', 'userName': '', timeStamp: '', 'ischange': 'No', 'id': '0', 'disable': false });
          //}
          var Presentdate = formatDate(this._Subscription.SubDetails[i - 1].startDate.jsdate)
          let changePresentdate = new Date(Presentdate);
          if (changePresentdate <= new Date() || (changePresentdate.getMonth() + 1 <= new Date().getMonth() + 1 && changePresentdate.getFullYear() <= new Date().getFullYear())) {
            this._Subscription.SubDetails.push({ 'status': 'Select', 'startDate': '', 'effecStartDate': '', 'renewalAmount': '', 'subscriptionType': 'Select', 'userName': '', timeStamp: '', 'ischange': 'No', 'id': '0', 'disable': false });
          }
        }
        else {
          this._Subscription.SubDetails.push(this.SubDet[i]);
          // this._Subscription.SubDetails
          this._Subscription.SubDetails[i].startDate = { jsdate: new Date(this._Subscription.SubDetails[i].startDate) }
          this._Subscription.SubDetails[i].effecStartDate = { jsdate: new Date(this._Subscription.SubDetails[i].effecStartDate) }
          //if (this._Subscription.SubDetails[i].bookingDate != null) {
          //  this._Subscription.SubDetails[i].bookingDate = { jsdate: new Date(this._Subscription.SubDetails[i].bookingDate) }
          //}
          //else {
          //  this._Subscription.SubDetails[i].bookingDate = '';
          //}
          var Presentdate = formatDate(this._Subscription.SubDetails[i].startDate.jsdate)
          let changePresentdate = new Date(Presentdate);
          if (changePresentdate > new Date() || (changePresentdate.getMonth() > new Date().getMonth() && changePresentdate.getFullYear() > new Date().getFullYear())) {


            this._Subscription.SubDetails[i].disable = false;
            this.disable = false;

          }
          else {
            this._Subscription.SubDetails[i].disable = true;

          }
          this._Subscription.SubDetails[i].timeStamp = new Date(this._Subscription.SubDetails[i].timeStamp).toLocaleString();
        }
      }
      //console.log(this._Subscription.SubDetails);
    });

  }



  public GetSubscriptionServices() {
    this._Subscriptions.GetSubscriptionServices(this._Subscription.Module, Number(this._Subscription.HotelId), Number(this._Subscription.TenantId)).subscribe(res => {
      if (res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          res[i].startDate = res[i].startDate ? { jsdate: new Date(res[i].startDate) } : "";
          res[i].endDate = res[i].endDate ? { jsdate: new Date(res[i].endDate) } : "";
          if (res[i].amount != null && !isNaN(res[i].amount)) {
            res[i].amount = parseFloat(res[i].amount).toFixed(2);
          }
        }
      }
      this.subscriptionServiceData = res;
    });

  }

  formatDateToMMDDYYYY(inputDate: string): string {
    const dateObj = new Date(inputDate);
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
  }
  public validateSubscriptionServicesData(): boolean {
    for (const data of this.subscriptionServiceData) {
      if (data.isMapped) {
        //if (!data.startDate) {
        //  this.toastr.warning(`Start Date is required for service: ${data.serviceName}`);
        //  return false;
        //}

        //if (!data.endDate) {
        //  this.toastr.warning(`End Date is required for service: ${data.serviceName}`);
        //  return false;
        //}

        if (data.amount == null || data.amount === '' || isNaN(Number(data.amount))) {
          this.toastr.error(`Please enter amount for service: ${data.serviceName}`);
          return false;
        }

        if ((data.startDate && data.endDate) && new Date(data.endDate) < new Date(data.startDate)) {
          this.toastr.warning(`End Date cannot be earlier than Start Date for service: ${data.serviceName}`);
          return false;
        }
      }
    }

    return true;
  }

  public OnSubscriptionServiceToggle(item: any): void {
    if (!item.isMapped) {
      item.startDate = null;
      item.endDate = null;
      item.amount = null;
    }
  }

  allowOnlyAmountInput(event: any, value: any) {
    const key = event.keyCode || event.which;
    const inputChar = String.fromCharCode(key);

    // Allow only numbers and one dot
    if (!/^[0-9.]$/.test(inputChar)) {
      event.preventDefault();
      return;
    }

    const currentValue = value ? value.toString() : '';

    // Prevent entering more than one dot
    if (inputChar === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return;
    }

    const input = event.target;
    const cursorPos = input.selectionStart || 0;
    const dotIndex = currentValue.indexOf('.');

    // Split into integer and decimal parts
    const [integerPart = '', decimalPart = ''] = currentValue.split('.');

    // Restrict to 9 digits before the decimal point
    const isTypingBeforeDot = dotIndex === -1 || cursorPos <= dotIndex;
    if (isTypingBeforeDot && inputChar !== '.' && integerPart.length >= 9) {
      event.preventDefault();
      return;
    }

    // Restrict to 2 digits after the decimal point
    if (dotIndex !== -1 && cursorPos > dotIndex && decimalPart.length >= 2) {
      event.preventDefault();
      return;
    }
  }

  formatAmount(item: any) {
    if (item.amount != null && item.amount != "" && !isNaN(item.amount)) {
      item.amount = parseFloat(item.amount).toFixed(2);
    }
  }

  restrictAmountOnPaste(event: ClipboardEvent) {
    let pastedData = '';

    if (event.clipboardData && event.clipboardData.getData) {
      pastedData = event.clipboardData.getData('text');
    }

    // Validate pasted value with regex: max 9 digits before decimal, optional decimal with max 2 digits after
    const regex = /^\d{1,9}(\.\d{0,2})?$/;

    if (!regex.test(pastedData)) {
      event.preventDefault();
    }
  }



  public getalluser() {
    this._EntityService.GetAccExecutives(this.type, this._Subscription.TenantId, this._Subscription.HotelId).subscribe(res => {
      this.AllAccExecutive.filter(p => p.Status == 'Acitve')
      this.AllAccExecutive = res;
    })

  }

  public getalllaborexporttypeformat() {
    this._EntityService.GetLaborExportTypeFormatForEntity(this.type, this._Subscription.TenantId).subscribe(res => {
      this.PayrollExportTypes = res;
    })

  }

  public getHoteltype() {
    this._EntityService.GetEditEntityDetails(this._Subscription.TenantId.toString(), this._Subscription.HotelId).subscribe(res => {
      //this.AllAccExecutive.filter(p => p.type == '1')
      this.AllAccExecutive = res;
    })

  }





  onSearchChange(searchValue: string): void {

    console.log(searchValue);
  }

  compareExportType = (a: any, b: any) => {
    return (a || '').toLowerCase() === (b || '').toLowerCase();
  };

  SaveSubscription() {

    this.isValidSubscription = true;
    this.btndisable = true;
    var len = this._Subscription.SubDetails.length;

    var IsTerDetValid = true;
    // console.log(this._Subscription);


    //if (this._Subscription.SubDetails[len - 1].renewalAmount == '' && this._Subscription.SubDetails[len - 1].status == 'Select' && this._Subscription.SubDetails[len - 1].startDate == "" && this._Subscription.SubDetails[len - 1].effecStartDate == "") {
    //  len = len - 1;
    //}







    if (this.SubsDetStatus == 'Inactive') {

      if (this._Subscription.ReasonForTermination == "-1" || this._Subscription.TerminationNotes == "" || this._Subscription.ReasonForTermination == null || this._Subscription.TerminationNotes == null) {
        IsTerDetValid = false;
        this.isValidSubscription = true;
        this.btndisable = false;
        return false;

      }

    }
    else {
      this._Subscription.TerminationDate = "";
      this._Subscription.ReasonForTermination = "";
      this._Subscription.TerminationNotes = "";
    }


    //let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) ? { } \/ ! # ]+$/i)
    //bool IsValidTerminationNotes = true;

    ////IsValidTerminationNotes = pattern.test(this._Subscription.TerminationNotes);
    //if (this.SubsDetStatus == 'Inactive') {
    //  if (IsValidTerminationNotes == false) {
    //    this.isValidSubscription = false;
    //    this.btndisable = false;
    //    this.toastr.error("Please enter valid characters in Termination Notes.");
    //    return;

    //  }
    //}


    if (this._Subscription.SubDetails.length > 1) {
      let LastStatus = this._Subscription.SubDetails[len - 2].status;
      if (LastStatus == this._Subscription.SubDetails[len - 1].status) {
        if (this._Subscription.SubDetails[len - 1].status == 'Inactive') {
          this.toastr.error("Subscription already terminated.");
          this.btndisable = false;
          return;
        }
      }

    }

    if (this._Subscription.SubDetails.length > 1) {
      let lastRenewalAmt = this._Subscription.SubDetails[len - 2].renewalAmount;
      if (lastRenewalAmt != this._Subscription.SubDetails[len - 1].renewalAmount) {
        if (this._Subscription.SubDetails[len - 1].status == 'Inactive') {
          this.toastr.error("Renewal amount should be equal to last renewal amount for termination.");
          this.btndisable = false;
          return;
        }
      }

    }
    if (this._Subscription.SubDetails.length > 2) {
      if (this._Subscription.SubDetails[len - 1].status != 'Active') {
        if (this._Subscription.SubDetails[len - 2].status == 'Inactive') {
          var arrSubs = this._Subscription.SubDetails;
          var index = arrSubs.findIndex(x => x.status === "Inactive");
          //var prevRenAmount = this._Subscription.SubDetails.slice(0, -1)[0].renewalAmount;
          var prevRenAmount = arrSubs[index - 1].renewalAmount;

          //var amountForTermination = this._Subscription.SubDetails[len - 2].renewalAmount;
          var amountForTermination = arrSubs[index].renewalAmount;

          if (prevRenAmount != amountForTermination) {
            this.toastr.error("Renewal amount should be equal to last renewal amount for termination.");
            this.btndisable = false;
            return;
          }
        }
      }
    }
    if (this.SubsDetStatus == 'Inactive') {
      this.getalluser(); //added on 5May23
    }
    else {
      this.getalluser();
      //this.getHoteltype();
    }


    //if (this._Subscription.SubDetails.length > 2) {
    //  if (this._Subscription.SubDetails[len - 1].status == 'Inactive' && this._Subscription.SubDetails[len - 1].renewalAmount =="") {

    //    var prevRenAmount = this._Subscription.SubDetails[len - 2].renewalAmount;
    //    var amountForTermination = this._Subscription.SubDetails[len - 1].renewalAmount;
    //    if (prevRenAmount != amountForTermination) {
    //      this.toastr.error("Renewal amount should be equal to last renewal amount for termination.");
    //      this.btndisable = false;
    //      return;
    //    }
    //  }
    //}



    //if (this._Subscription.SubDetails.length > 1) {
    //  if (this._Subscription.SubDetails[len - 1].status == 'Inactive') {
    //    var prevRenAmount = this._Subscription.SubDetails[len - 2].renewalAmount;

    //    var amountForTermination = this._Subscription.SubDetails[len - 1].renewalAmount;

    //    if (prevRenAmount != amountForTermination) {
    //      this.toastr.error("Renewal amount should be equal to last renewal amount for termination.");
    //      this.btndisable = false;
    //      return;
    //    }
    //  }
    // else if (this._Subscription.SubDetails.slice(-2, -1)[0].status == 'Inactive')
    //  {
    //    var prevRenAmount = this._Subscription.SubDetails.slice(-2, -1)[0].renewalAmount;

    //    var amountForTermination = this._Subscription.SubDetails.slice(-2, -1)[0].renewalAmount;
    //if (amountForTermination == "") {
    //  amountForTermination = prevRenAmount;
    //}

    //   if (prevRenAmount != amountForTermination) {
    ///    this.toastr.error("Renewal amount should be equal to last renewal amount for termination.");
    //    this.btndisable = false;
    //    return;
    //  }
    //}
    //}

    if (this._Subscription.SubDetails.length > 1) {

      let datelast;
      let datesecondlast;

      if (this._Subscription.SubDetails[len - 1].startDate != null) {
        if (!this._Subscription.SubDetails[len - 1].startDate.jsdate) {
          datelast = this._Subscription.SubDetails[len - 1].startDate;
        }
        else {
          datelast = formatDate(this._Subscription.SubDetails[len - 1].startDate.jsdate);
        }
      }
      else {
        this._Subscription.SubDetails[len - 1].startDate = "";
      }

      if (this._Subscription.SubDetails[len - 2].startDate != null) {
        if (!this._Subscription.SubDetails[len - 2].startDate.jsdate) {
          datesecondlast = this._Subscription.SubDetails[len - 2].startDate;
        }
        else {
          datesecondlast = formatDate(this._Subscription.SubDetails[len - 2].startDate.jsdate);
        }
      }
      else {
        this._Subscription.SubDetails[len - 2].startDate = "";
      }

      if (this._Subscription.SubDetails[len - 1].startDate == "" || this._Subscription.SubDetails[len - 2].startDate == "") {
        let newlastdate = new Date(datelast);
        //this._Subscription.TerminationDate = newlastdate;
        let newdatesecondlast = new Date(datesecondlast);

        if (new Date(datelast) < new Date(datesecondlast) || (new Date(datelast).getMonth() <= new Date(datesecondlast).getMonth() && new Date(datelast).getFullYear() <= new Date(datesecondlast).getFullYear())) {
          this.toastr.error("Billing Date should be greater than the previous subscription Billing Date");
          this.btndisable = false;
          return;
        }

      }
      let effecdatelast;
      let effecdatesecondlast;

      if (this._Subscription.SubDetails[len - 1].effecStartDate != null) {
        if (!this._Subscription.SubDetails[len - 1].effecStartDate.jsdate) {
          effecdatelast = this._Subscription.SubDetails[len - 1].effecStartDate;
        }
        else {
          effecdatelast = formatDate(this._Subscription.SubDetails[len - 1].effecStartDate.jsdate);
        }
      }
      else {
        this._Subscription.SubDetails[len - 1].effecStartDate = "";
      }

      if (this._Subscription.SubDetails[len - 2].effecStartDate != null) {
        if (!this._Subscription.SubDetails[len - 2].effecStartDate.jsdate) {
          effecdatesecondlast = this._Subscription.SubDetails[len - 2].effecStartDate;
        }
        else {
          effecdatesecondlast = formatDate(this._Subscription.SubDetails[len - 2].effecStartDate.jsdate);
        }
      }
      else {
        this._Subscription.SubDetails[len - 2].effecStartDate = "";
      }

      if (this._Subscription.SubDetails[len - 1].effecStartDate == "" || this._Subscription.SubDetails[len - 2].effecStartDate == "") {
        let neweffeclastdate = new Date(effecdatelast);
        //this._Subscription.TerminationDate = newlastdate;
        let newdatesecondlast = new Date(effecdatesecondlast);

        if (new Date(effecdatelast) < new Date(effecdatesecondlast) || (new Date(effecdatelast).getMonth() <= new Date(effecdatesecondlast).getMonth() && new Date(effecdatelast).getFullYear() <= new Date(effecdatesecondlast).getFullYear())) {
          this.toastr.error("Effective Start Date should be greater than the previous subscription Effective Start Date");
          this.btndisable = false;
          return;
        }

      }

      //let bookingdatelast;
      //let bookingdatesecondlast;

      //if (this._Subscription.SubDetails[len - 1].bookingDate != null) {
      //  if (!this._Subscription.SubDetails[len - 1].bookingDate.jsdate) {
      //    bookingdatelast = this._Subscription.SubDetails[len - 1].bookingDate;
      //  }
      //  else {
      //    bookingdatelast = formatDate(this._Subscription.SubDetails[len - 1].bookingDate.jsdate);
      //  }
      //}
      //else {
      //  this._Subscription.SubDetails[len - 1].bookingDate = "";
      //}

      //if (this._Subscription.SubDetails[len - 2].bookingDate != null) {
      //  if (!this._Subscription.SubDetails[len - 2].bookingDate.jsdate) {
      //    bookingdatesecondlast = this._Subscription.SubDetails[len - 2].bookingDate;
      //  }
      //  else {
      //    bookingdatesecondlast = formatDate(this._Subscription.SubDetails[len - 2].bookingDate.jsdate);
      //  }
      //}
      //else {
      //  this._Subscription.SubDetails[len - 2].bookingDate = "";
      //}

      //if (this._Subscription.SubDetails[len - 1].bookingDate == "" || this._Subscription.SubDetails[len - 2].bookingDate == "") {
      //  let firstBDateLast = new Date(bookingdatelast);
      //  //this._Subscription.TerminationDate = newlastdate;
      //  let SecondBDateSecondLast = new Date(bookingdatesecondlast);

      //  if (new Date(bookingdatelast) < new Date(bookingdatesecondlast) || (new Date(bookingdatelast).getMonth() <= new Date(bookingdatesecondlast).getMonth() && new Date(bookingdatelast).getFullYear() <= new Date(bookingdatesecondlast).getFullYear())) {
      //    this.toastr.error("Booking Date should be greater than the previous subscription Booking Date");
      //    this.btndisable = false;
      //    return;
      //  }

      //}

      //if (this._Subscription.SubDetails[len - 1].bookingDate != "" && this._Subscription.SubDetails[len - 1].startDate != "") {
      //  if (this._Subscription.SubDetails[len - 1].bookingDate >= this._Subscription.SubDetails[len - 1].startDate) {
      //    if (this._Subscription.SubDetails[len - 1].bookingDate > this._Subscription.SubDetails[len - 1].startDate) {
      //      this.toastr.error("Booking date should be less than Start date.");
      //    }
      //    else {
      //      this.toastr.error("Start date should be more than Booking date.");
      //    }
      //    // this.loading = false;
      //    this.btndisable = false;
      //    return;
      //  }
      //}


    }
    //else if (this._Subscription.SubDetails.length = 1) {
    //  if (this._Subscription.SubDetails[len - 1].status == 'Inactive' && this._Subscription.subscriptionId == "") {
    //    this.toastr.error("")
    //  }
    //}
    this._Subscription.SubDetails[len - 1].ischange = 'Yes';
    let currenttype = this._Subscription.SubDetails[len - 1].subscriptionType;
    let currentstatus = this._Subscription.SubDetails[len - 1].status;
    this.SubscriptionDet.SubDetCheck = this._Subscription.SubDetails;
    this.SubscriptionDet.SubDetails = this._Subscription.SubDetails.filter(p => p.ischange == 'Yes');

    for (let i = 0; i <= this.SubscriptionDet.SubDetails.length - 1; i++) {

      if (this.SubscriptionDet.SubDetails[i].startDate != null) {
        if (!this.SubscriptionDet.SubDetails[i].startDate.jsdate) {
          this.SubscriptionDet.SubDetails[i].startDate = this.SubscriptionDet.SubDetails[i].startDate;
        }
        else {
          this.SubscriptionDet.SubDetails[i].startDate = formatDate(this.SubscriptionDet.SubDetails[i].startDate.jsdate);
        }
      }
      if (this.SubscriptionDet.SubDetails[i].effecStartDate != null) {
        if (!this.SubscriptionDet.SubDetails[i].effecStartDate.jsdate) {
          this.SubscriptionDet.SubDetails[i].effecStartDate = this.SubscriptionDet.SubDetails[i].effecStartDate;
        }
        else {
          this.SubscriptionDet.SubDetails[i].effecStartDate = formatDate(this.SubscriptionDet.SubDetails[i].effecStartDate.jsdate);
        }
      }

      //if (this.SubscriptionDet.SubDetails[i].bookingDate != null) {
      //  if (!this.SubscriptionDet.SubDetails[i].bookingDate.jsdate) {
      //    this.SubscriptionDet.SubDetails[i].bookingDate = this.SubscriptionDet.SubDetails[i].bookingDate;
      //  }
      //  else {
      //    this.SubscriptionDet.SubDetails[i].bookingDate = formatDate(this.SubscriptionDet.SubDetails[i].bookingDate.jsdate);
      //  }
      //}
      //if (this.SubscriptionDet.SubDetails[i].bookingDate != "" && this.SubscriptionDet.SubDetails[i].startDate != "") {
      //  if (this._Subscription.SubDetails[i].bookingDate >= this.SubscriptionDet.SubDetails[i].startDate) {
      //    if (this._Subscription.SubDetails[i].bookingDate > this.SubscriptionDet.SubDetails[i].startDate) {
      //      this.toastr.error("Booking date should be less than Start date.");
      //    }
      //    else {
      //      this.toastr.error("Start date should be more than Booking date.");
      //    }
      //    this.loading = false;
      //    return;
      //}


      this.SubscriptionDet.SubDetails[i].HotelId = this._Subscription.HotelId;
      this.SubscriptionDet.SubDetails[i].TenantId = this._Subscription.TenantId;
      this.SubscriptionDet.SubDetails[i].subscriptionId = this._Subscription.subscriptionId;
      this.SubscriptionDet.SubDetails[i].usernameother = sessionStorage.getItem('UserName');

      if (this.SubsDetStatus == 'Inactive') {
        this._Subscription.TerminationDate = this.SubscriptionDet.SubDetails[i].startDate;
        this.SubscriptionDet.SubDetails[i].TerminationDate = this.SubscriptionDet.SubDetails[i].startDate;


      }
      else {
        this.SubscriptionDet.SubDetails[i].TerminationDate = "";
      }
      this.SubscriptionDet.SubDetails[i].ReasonForTermination = this._Subscription.ReasonForTermination;
      this.SubscriptionDet.SubDetails[i].TerminationNotes = this._Subscription.TerminationNotes;
      this.SubscriptionDet.SubDetails[i].TerminationStatus = this.SubsDetStatus;


      //this.SubscriptionDet.SubDetails[i].userName = sessionStorage.getItem('UserName');
      //this.SubscriptionDet.SubDetails[i].timeStamp = new Date().toLocaleString();
    }
    var TerminationDate;
    if (this._Subscription.SubDetails.length > 0) {
      if (this._Subscription.SubDetails[len - 1].status == "Inactive") {

        if (!this._Subscription.SubDetails[len - 1].startDate.jsdate) {
          TerminationDate = this._Subscription.SubDetails[len - 1].startDate;
        }
        else {
          TerminationDate = formatDate(this._Subscription.SubDetails[len - 1].startDate.jsdate);
        }
        var _CurrDate = formatDate(new Date()).split("/");
        var _DateYear = _CurrDate[0];
        var _DateMonth = _CurrDate[1];

        var _finaldate = _DateMonth + '/01/' + _DateYear;

        console.log(new Date(_finaldate));
        if (new Date(TerminationDate) < new Date(_finaldate)) {
          this.toastr.error("Termination Date month Should be greater than Current Date month.");
          this.btndisable = false;
          return;
        }
      }
    }
    if (this._Subscription.SubDetails.length > 1) {
      if (this._Subscription.SubDetails[len - 2].status == "Inactive") {
        if (this._Subscription.SubDetails[len - 2].ischange == 'Yes') {
          if (!this._Subscription.SubDetails[len - 2].startDate.jsdate) {
            TerminationDate = this._Subscription.SubDetails[len - 2].startDate;
          }
          else {
            TerminationDate = formatDate(this._Subscription.SubDetails[len - 2].startDate.jsdate);
          }
          var _CurrDate = formatDate(new Date()).split("/");
          var _DateYear = _CurrDate[0];
          var _DateMonth = _CurrDate[1];

          var _finaldate = _DateMonth + '/01/' + _DateYear;

          console.log(new Date(_finaldate));
          if (new Date(TerminationDate) < new Date(_finaldate)) {
            this.toastr.error("Termination Date month Should be greater than Current Date month.");
            this.btndisable = false;
            return;
          }
        }
      }
    }


    this.ValidateSubscriptionDetails();
    //
    this.validateSubscriptionDet();

    if (this.validatesub == true) {
      var lenSubdet = this.SubscriptionDet.SubDetails.length;
      if (this.SubscriptionDet.SubDetails[lenSubdet - 1].renewalAmount == null || this.SubscriptionDet.SubDetails[lenSubdet - 1].subscriptionType == "Select" || this.SubscriptionDet.SubDetails[lenSubdet - 1].status == "Select" || this.SubscriptionDet.SubDetails[lenSubdet - 1].startDate == "") {
        this.SubscriptionDet.SubDetails.splice(lenSubdet - 1, 1);
      }
      this._Subscriptions.SaveSubscriptions(this.SubscriptionDet).subscribe(res => {

        var data = res;
        if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
          this.toastr.success(data.message);
          if (this.SubscriptionDet.SubDetails.length > 0) {
            this.SubscriptionDet.SubDetails[this.SubscriptionDet.SubDetails.length - 1].ischange = 'No';
            //if (currenttype != 'Select' || currentstatus != 'Select') {
            //  this._Subscription.SubDetails.push({ 'status': 'Select', 'startDate': '', 'renewalAmount': 0, 'subscriptionType': 'Select', 'userName': '', timeStamp: '', 'ischange': 'No', 'id': '0' });
            //}
          }
          this.SubscriptionDet = {};
          this.CloseSubscription();
          this.SubDet = {};
          //if (this._Subscription.SubDetails != undefined) {
          this._Subscription.SubDetails = [];
          //}
          this.Editdata();
          this.getSubscriptionDetails();
        }
        else {

          this.toastr.error(data.message);
          this.btndisable = false;
        }
      });
    }
    else {
      this.btndisable = false;
    }
  }


  onDateChanged(event: IMyDateModel) {
    if (this._Subscription.Module == 'Accounting' && this.DateChange == 'New') {
      if (!this._Subscription.StartDate.jsdate) {
        this._Subscription.DataStartDate = { jsdate: new Date(this._Subscription.StartDate) };
      }
      else {
        this._Subscription.DataStartDate = {
          jsdate: new Date(this._Subscription.StartDate.jsdate)
        };
      }
      this.DateChange = 'Change';
    }
  }


  SetdOTW(PayPeriodstartDate: any) {

    if (!PayPeriodstartDate.jsdate)
      var Actualdate = new Date(PayPeriodstartDate);
    else {
      Actualdate = new Date(formatDate(PayPeriodstartDate.jsdate));
    }
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    this.PayperiodDowStartDate = weekday[new Date(Actualdate).getDay()];
    this.payPeriodStartCheck = formatDate(PayPeriodstartDate.formatted);
    if (this.payPeriodStartCheck == "NaN/NaN/NaN") {
      this.payPeriodStartCheck = "";
    }
    // 
  }

  SetdOTW1(StartPayDate: any) {
    if (!StartPayDate.jsdate)
      var Actualdate = new Date(StartPayDate);
    else {
      Actualdate = new Date(formatDate(StartPayDate.jsdate));
    }
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    this.StartDowPayDate = weekday[new Date(Actualdate).getDay()];
  }

  SetdOTW2(PayrollProcessingDate: any) {
    if (!PayrollProcessingDate.jsdate)
      var Actualdate = new Date(PayrollProcessingDate);
    else {
      Actualdate = new Date(formatDate(PayrollProcessingDate.jsdate));
    }
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    this.PayrollDowPayDate = weekday[new Date(Actualdate).getDay()];
  }

  ValidateSubscriptionDetails() {

    for (let i = 0; i <= this.SubscriptionDet.SubDetCheck.length - 1; i++) {


      if (i == this.SubscriptionDet.SubDetCheck.length - 1) {
        if (this.SubscriptionDet.SubDetCheck[i].renewalAmount != "" || this.SubscriptionDet.SubDetCheck[i].subscriptionType != "Select" || this.SubscriptionDet.SubDetCheck[i].status != "Select" || this.SubscriptionDet.SubDetCheck[i].startDate != "" || this.SubscriptionDet.SubDetCheck[i].effecStartDate != "") {
          if (this.SubscriptionDet.SubDetCheck[i].renewalAmount.toString() == "") {
            this.toastr.error("Please enter the renewal amount");
            this.validatesub = false;
            return;
          }


          else if (this.SubscriptionDet.SubDetCheck[i].subscriptionType == "Select") {
            this.toastr.error("Please select the subscription type ");
            this.validatesub = false;
            return;
          }
          else if (this.SubscriptionDet.SubDetCheck[i].status == "Select") {
            this.toastr.error("Please select the subscription status ");
            this.validatesub = false;
            return;
          }
          else if (this.SubscriptionDet.SubDetCheck[i].startDate == null || this.SubscriptionDet.SubDetCheck[i].startDate == "") {
            this.toastr.error("Please select the Billing Date");
            this.validatesub = false;
            return;
          }
          else if (this.SubscriptionDet.SubDetCheck[i].effecStartDate == null || this.SubscriptionDet.SubDetCheck[i].effecStartDate == "") {
            this.toastr.error("Please select the Effective Date");
            this.validatesub = false;
            return;
          }
          else {
            this.validatesub = true;
          }
        }
      }
      else {
        if (this.SubscriptionDet.SubDetCheck[i].renewalAmount.toString() == "") {
          this.toastr.error("Please enter the renewal amount  ");
          this.validatesub = false;
          return;
        }
        else if (this.SubscriptionDet.SubDetCheck[i].subscriptionType == "Select") {
          this.toastr.error("Please enter the subscription type");
          this.validatesub = false;
          return;
        }
        else if (this.SubscriptionDet.SubDetCheck[i].status == "Select") {
          this.toastr.error("Please enter the subscription status");
          this.validatesub = false;
          return;
        }
        else if (this.SubscriptionDet.SubDetCheck[i].startDate == null || this.SubscriptionDet.SubDetCheck[i].startDate == "") {
          this.toastr.error("Please select the Billing Date. ");
          this.validatesub = false;
          return;
        }
        else if (this.SubscriptionDet.SubDetCheck[i].effecStartDate == null || this.SubscriptionDet.SubDetCheck[i].effecStartDate == "") {
          this.toastr.error("Please select the Effective Date");
          this.validatesub = false;
          return;
        }
        else {
          this.validatesub = true;
        }
      }
    }


  }


  validateSubscriptionDet() {
    //
    var Firstdate;
    var Secondtdate;
    var effecFirstdate;
    var effecSecondtdate;
    var bookingFirstDate;
    var bookingSecondDate;
    this.SubscriptionDet.SubDetCheck = this.SubscriptionDet.SubDetCheck.filter(p => p.startDate != '')
    for (let i = 0; i <= this.SubscriptionDet.SubDetCheck.length - 2; i++) {
      if (!this.SubscriptionDet.SubDetCheck[i].startDate.jsdate) {
        Firstdate = new Date(this.SubscriptionDet.SubDetCheck[i].startDate);
      }
      else {
        Firstdate = new Date(formatDate(this.SubscriptionDet.SubDetCheck[i].startDate.jsdate));
      }
      if (!this.SubscriptionDet.SubDetCheck[i + 1].startDate.jsdate) {

        Secondtdate = new Date(this.SubscriptionDet.SubDetCheck[i + 1].startDate);
      }
      else {
        Secondtdate = new Date(formatDate(this.SubscriptionDet.SubDetCheck[i + 1].startDate.jsdate));
      }

      if (!this.SubscriptionDet.SubDetCheck[i].effecStartDate.jsdate) {
        effecFirstdate = new Date(this.SubscriptionDet.SubDetCheck[i].effecStartDate);
      }
      else {
        effecFirstdate = new Date(formatDate(this.SubscriptionDet.SubDetCheck[i].effecStartDate.jsdate));
      }
      if (!this.SubscriptionDet.SubDetCheck[i + 1].effecStartDate.jsdate) {

        effecSecondtdate = new Date(this.SubscriptionDet.SubDetCheck[i + 1].effecStartDate);
      }
      else {
        effecSecondtdate = new Date(formatDate(this.SubscriptionDet.SubDetCheck[i + 1].effecStartDate.jsdate));
      }



      var secondstatus = this.SubscriptionDet.SubDetCheck[i + 1].status;
      //if (secondstatus == "Active") {


      if (secondstatus == "Inactive") {

        if (Firstdate.getMonth() > Secondtdate.getMonth() && Firstdate.getFullYear() > Secondtdate.getFullYear()) {
          this.toastr.error("The Billing Date of the last subscription should be greater than the earlier listed Billing Date.");
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].userName = '';
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].timeStamp = '';
          this.validatesub = false;
          return;
        }

        if (effecFirstdate.getMonth() > effecSecondtdate.getMonth() && effecFirstdate.getFullYear() > effecSecondtdate.getFullYear()) {
          this.toastr.error("The Effective Start Date of the last subscription should be greater than the earlier listed Effective Start Date.");
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].userName = '';
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].timeStamp = '';
          this.validatesub = false;
          return;
        }


      }
      else {


        if (Firstdate >= Secondtdate) {
          this.toastr.error("The Billing Date of the last subscription should be greater than the earlier listed Billing Date.");
          //this.SubscriptionDet.su[i].userName = '';
          //this.SubscriptionDet.SubDetCheck[i].timeStamp = '';
          this.validatesub = false;
          return;

        }
        else if (Firstdate.getMonth() >= Secondtdate.getMonth() && Firstdate.getFullYear() >= Secondtdate.getFullYear()) {
          this.toastr.error("The Billing Date of the last subscription should be greater than the earlier listed Billing Date.");
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].userName = '';
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].timeStamp = '';
          this.validatesub = false;
          return;
        }

        //if (secondstatus == "Active") {
        if (effecFirstdate >= effecSecondtdate) {
          this.toastr.error("The Effective Start Date of the last subscription should be greater than the earlier listed Effective Start Date.");
          //this.SubscriptionDet.su[i].userName = '';
          //this.SubscriptionDet.SubDetCheck[i].timeStamp = '';
          this.validatesub = false;
          return;

        }
        else if (effecFirstdate.getMonth() >= effecSecondtdate.getMonth() && effecFirstdate.getFullYear() >= effecSecondtdate.getFullYear()) {
          this.toastr.error("The Effective Start Date of the last subscription should be greater than the earlier listed Effective Start Date.");
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].userName = '';
          //this.SubscriptionDet.SubDetCheck[this.SubscriptionDet.SubDetCheck.length - 1].timeStamp = '';
          this.validatesub = false;
          return;
        }

        //}
      }
    }
  }

  ValidationSubscriptionStartDate() {
    this._Subscriptions.GetLatestSubsDate(this._Subscription.subscriptionId.toString(), this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString()).subscribe(res => {
      var data = res;
      this.QuerySDate = formatDate(data[0].startdate);
      this.QueryEffDate = formatDate(data[0].effectivestartdate);
    });
  }



  ValidateDateStartDate() {
    this._Subscriptions.GetCompareDate(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString()).subscribe(res => {
      var data = res;
      if (data.length != 0) {
        this.CompareDate = data[0].comparedate;
        console.log(data);
      }
    });
  }

  ValidateSubscription() {

    if (this._Subscription.Module == "Payroll Service" || this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
      this._Subscriptions.GetEditSubSearchResult(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString(), '', 'STATUS').subscribe(res => {
        var data = res.length;
        if (data == 0) {
          //this.toastr.error("Given Entity does not have Labor Management.Please add Labour Management Subscription first to add Payroll Services.");
          if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
            this.toastr.error("Payroll - CheckHQ subscription cannot be added as Labor Management module is not subscribed yet.");
          }
          else {
            this.toastr.error("Payroll Service subscription cannot be added as Labor Management module is not subscribed yet.");
          }
          this.Validate = false;
        }
        else {
          this.Validate = true;
          this.ValidateDate();
        }
      });

    }
    if(this.Validate == true && this._Subscription.Module == SubscriptionModule.PayrollCheckHQ){
      this.LoadSignatory();
    }
    if (this._Subscription.Module == "Labor Management") {
      //this.Validate = true;
      this.ValidateDate();
    }
  }

  ValidateDate() {
    this._Subscriptions.GetEditSubSearchResult(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString(), '', 'LABOR STATUS').subscribe(res => {
      var data = res;
      this.QueryPayrollStartDate = data[0].payrollStartdate;
      this.QueryWeeklyLayout = data[0].weekLayOut;
      this.QueryWeeklyDate = data[0].payrollStartdate;
      console.log(data[0]);
    });
  }

  CheckPayrollHid(type: string) {
    this._Subscriptions.CheckPayrollHid(this._Subscription.HotelId.toString(), type, this._Subscription.TenantId.toString()).subscribe(res => {
      var data = res;
      if (type == '1' && data.length > 0) {
        alert("Send mail to client to complete  the user information for E/HID's that has payroll activated.");
        this._Subscription.Payroll = false;
      }
      else if (type == '2' && data.length > 0) {
        this.Payrollarray = data;
        console.log(this.Payrollarray);
        this.modelRemovepayroll = "block";
      }
    });
  }

  LoadSignatory() {
    this.isSignatoryEditable = true;

    if (this._Subscription.HotelId && this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
      const hotelId = typeof this._Subscription.HotelId === 'string' ? parseInt(this._Subscription.HotelId) : this._Subscription.HotelId;
      this._signatoryService.GetSignatoryByHotelID(hotelId).subscribe(
        res => {
          // Response is { Signatory, StartDateLockReason }; tolerate both PascalCase and camelCase.
          const signatoryRaw = res ? (res.Signatory || res.signatory || res) : null;
          const lockReasonRaw = res ? (res.StartDateLockReason || res.startDateLockReason || 'None') : 'None';
          const lockReason: StartDateLockReason = (lockReasonRaw as StartDateLockReason) || 'None';

          if (signatoryRaw && (signatoryRaw.SignatoryId || signatoryRaw.signatoryId)) {
            // Existing signatory record loaded.
            if (signatoryRaw.hotelId != this._Subscription.HotelId && signatoryRaw.HotelId != this._Subscription.HotelId) {
              this.isSignatoryEditable = false;
            }

            const signatoryId = signatoryRaw.SignatoryId || signatoryRaw.signatoryId;
            const firstName = signatoryRaw.FirstName || signatoryRaw.firstName || '';
            const lastName = signatoryRaw.LastName || signatoryRaw.lastName || '';
            const email = signatoryRaw.Email || signatoryRaw.email || '';
            const title = signatoryRaw.Title || signatoryRaw.title || '';
            const resHotelId = signatoryRaw.HotelId || signatoryRaw.hotelId;
            const hotelIdResolved = resHotelId ? (typeof resHotelId === 'number' ? resHotelId : parseInt(resHotelId)) : (typeof this._Subscription.HotelId === 'string' ? parseInt(this._Subscription.HotelId) : this._Subscription.HotelId);
            const startDateRaw = signatoryRaw.StartDate || signatoryRaw.startDate || null;
            const startDateIso = startDateRaw ? this.normalizeIsoDate(startDateRaw) : null;

            if (this.sigForm) {
              this.sigForm.signatoryModel = {
                signatoryId: signatoryId ? signatoryId.toString() : undefined,
                title: title,
                firstName: firstName,
                lastName: lastName,
                email: email,
                hotelId: hotelIdResolved,
                startDate: startDateIso
              };
              this.sigForm.setStartDateLockState(lockReason);
              this.sigForm.refreshStartDateModel();
            }
          } else if (this.sigForm) {
            // No existing record — apply lock state to a fresh model.
            this.sigForm.setStartDateLockState(lockReason);
          }
        },
        error => {
          console.error('Error loading signatory', error);
        }
      );
    }
  }

  private normalizeIsoDate(raw: any): string | null {
    if (!raw) return null;
    if (typeof raw === 'string') {
      // Server returns ISO yyyy-MM-dd (or full ISO datetime). Trim to date portion.
      return raw.length >= 10 ? raw.substring(0, 10) : null;
    }
    return null;
  }

  private get shouldPersistSignatory(): boolean {
    return !!this.sigForm && (this.isSignatoryEditable || this.sigForm.isStartDateEditable);
  }

  private performSaveSignatory() {
    const signatorydata: Signatory = this.sigForm.getModel();
    if (signatorydata && this.shouldPersistSignatory) {
      this.isSavingSignatory = true;
      const hotelId = typeof this._Subscription.HotelId === 'string' ? parseInt(this._Subscription.HotelId) : this._Subscription.HotelId;
      this.sigForm.setHotelID(hotelId);
      signatorydata.hotelId = signatorydata.hotelId ? signatorydata.hotelId : hotelId;
      this._signatoryService.SaveSignatory(signatorydata).subscribe(
        res => {
          // Store the signatoryId after save/update
          if (res && (res.SignatoryId || res.signatoryId)) {
            const signatoryId = res.SignatoryId || res.signatoryId;
            this.sigForm.signatoryModel.signatoryId = signatoryId ? signatoryId.toString() : undefined;
          }
          // Re-sync the child's captured original to the saved value so a subsequent
          // save without further edits won't re-prompt.
          this.sigForm.refreshStartDateModel();
          this.isSavingSignatory = false;
        },
        error => {
          console.error('Error saving signatory', error);
          this.isSavingSignatory = false;
        }
      );
    }
  }

  totalEmployeesChanged(totalEmployees: string) {
    this._Subscription.TotalEmployees = totalEmployees;
  }

  
  CloseRemovepayroll() {
    this.modelRemovepayroll = "none";
  }

  onChangePayFreqAndDate(payPeriodwise: any) {

    this.oldpayPeriodFrequency = payPeriodwise;

    //this.StartDowPayDate == this.payPeriodStartCheck;

  }

  SaveSuscriptionDetails(form: NgForm) {
    // Prevent multiple simultaneous saves
    if (this.loading || this.isSavingSignatory) {
      return;
    }
    
    if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
      if (this.shouldPersistSignatory && !this.sigForm.isValid()) {
        this.toastr.error("Additional Questions are invalid. Please correct them before saving the subscription.");
        return;
      }

      // Gate the ENTIRE save on the start-date confirmation. The dialog is async, so we
      // must stop here and re-enter once the user responds — otherwise the subscription
      // save below runs immediately and its reload (Editdata -> LoadSignatory) resets the
      // new date before the user can confirm. startDateConfirmed prevents re-prompting.
      if (this.sigForm.hasStartDateChanged() && !this.startDateConfirmed) {
        if (this.isStartDateDialogOpen) {
          return;
        }
        this.isStartDateDialogOpen = true;
        this.confirmDialogService.confirmThis(
          "Changing the Start Date affects this company's interaction with CheckHQ. The date should be set as close as possible to the company's first payroll day. Continue?",
          () => {
            this.isStartDateDialogOpen = false;
            this.startDateConfirmed = true;
            this.SaveSuscriptionDetails(form);
          },
          () => {
            // Cancel: abort the entire save (no signatory or subscription request) and
            // reset the start date back to its original value.
            this.isStartDateDialogOpen = false;
            this.startDateConfirmed = false;
            this.sigForm.revertStartDate();
          }
        );
        return;
      }

      // Confirmed, or no change — persist the signatory without re-prompting.
      this.startDateConfirmed = false;
      this.performSaveSignatory();
    }

    if (form.valid && this._Subscription.Trainer != -1 && this._Subscription.Status != "-1" && this._Subscription.Module != '-1' && this._Subscription.ImplementationStatus != "-1") {

      this.loading = true;



      if (this.Validate == true || (this._Subscription.Module != 'Payroll Service' && this._Subscription.Module != SubscriptionModule.PayrollCheckHQ)) {


        if (this._Subscription.BookingDate != null || this._Subscription.BookingDate != undefined) {
          if (!this._Subscription.BookingDate.jsdate) {
            this._Subscription.BookingDate = this._Subscription.BookingDate;
          }
          else {
            this._Subscription.BookingDate = formatDate(this._Subscription.BookingDate.jsdate);
          }
        }
        else {
          this._Subscription.BookingDate = "";
        }
        //if (!this._Subscription.BookingDate.jsdate) {
        //  var date = new Date(this._Subscription.BookingDate);
        //  this._Subscription.BookingDate = new Date(date.getFullYear(), date.getMonth(), 1);
        //  this._Subscription.BookingDate = formatDate(this._Subscription.BookingDate);
        //}
        //else {
        //  var date = new Date(this._Subscription.BookingDate.jsdate);
        //  this._Subscription.BookingDate = { jsdate: new Date(date.getFullYear(), date.getMonth(), 1) }
        //  this._Subscription.BookingDate = formatDate(this._Subscription.BookingDate.jsdate);
        //}

        if (!this._Subscription.StartDate.jsdate) {
          var date = new Date(this._Subscription.StartDate);
          this._Subscription.StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this._Subscription.StartDate = formatDate(this._Subscription.StartDate);
        }
        else {
          var date = new Date(this._Subscription.StartDate.jsdate);
          this._Subscription.StartDate = { jsdate: new Date(date.getFullYear(), date.getMonth(), 1) }
          this._Subscription.StartDate = formatDate(this._Subscription.StartDate.jsdate);
        }

        if (!this._Subscription.EffectiveStartDate.jsdate) {
          var date = new Date(this._Subscription.EffectiveStartDate);
          this._Subscription.EffectiveStartDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this._Subscription.EffectiveStartDate = formatDate(this._Subscription.EffectiveStartDate);
        }
        else {
          var date = new Date(this._Subscription.EffectiveStartDate.jsdate);
          this._Subscription.EffectiveStartDate = { jsdate: new Date(date.getFullYear(), date.getMonth(), 1) }
          this._Subscription.EffectiveStartDate = formatDate(this._Subscription.EffectiveStartDate.jsdate);
        }

        if (!this._Subscription.FullsubscriptionStartDate.jsdate) {
          this._Subscription.FullsubscriptionStartDate = this._Subscription.FullsubscriptionStartDate;
        }
        else {
          this._Subscription.FullsubscriptionStartDate = formatDate(this._Subscription.FullsubscriptionStartDate.jsdate);
        }
        if (this._Subscription.ImpCompletionDate != null || this._Subscription.ImpCompletionDate != undefined) {
          if (!this._Subscription.ImpCompletionDate.jsdate) {
            this._Subscription.ImpCompletionDate = this._Subscription.ImpCompletionDate;
          }
          else {
            this._Subscription.ImpCompletionDate = formatDate(this._Subscription.ImpCompletionDate.jsdate);
          }
        }
        else {
          this._Subscription.ImpCompletionDate = "";
        }


        if (this._Subscription.DataStartDate != undefined) {
          if (!this._Subscription.DataStartDate.jsdate) {
            this._Subscription.DataStartDate = this._Subscription.DataStartDate;
          }
          else {
            this._Subscription.DataStartDate = formatDate(this._Subscription.DataStartDate.jsdate);
          }
        }
        else {
          this._Subscription.DataStartDate = "";
        }

        if (this._Subscription.PayPeriodStartDate != undefined) {
          if (!this._Subscription.PayPeriodStartDate.jsdate) {
            this._Subscription.PayPeriodStartDate = this._Subscription.PayPeriodStartDate;
          }
          else {
            this._Subscription.PayPeriodStartDate = formatDate(this._Subscription.PayPeriodStartDate.jsdate);
          }
        }
        else {
          this._Subscription.PayPeriodStartDate = "";
        }
        if (this._Subscription.PayrollProcessingDate != undefined) {
          if (!this._Subscription.PayrollProcessingDate.jsdate) {
            this._Subscription.PayrollProcessingDate = this._Subscription.PayrollProcessingDate;
          }
          else {
            this._Subscription.PayrollProcessingDate = formatDate(this._Subscription.PayrollProcessingDate.jsdate);
          }
        }
        else {
          this._Subscription.PayrollProcessingDate = "";
        }



        if (this._Subscription.StartPayDate != undefined) {
          if (!this._Subscription.StartPayDate.jsdate) {
            this._Subscription.StartPayDate = this._Subscription.StartPayDate;
          }
          else {
            this._Subscription.StartPayDate = formatDate(this._Subscription.StartPayDate.jsdate);
          }
        }
        else {
          this._Subscription.StartPayDate = "";
        }
        //if (this._Subscription.Status == "Inactive") {
        if (!this._Subscription.TerminationDate.jsdate) {
          this._Subscription.TerminationDate = this._Subscription.TerminationDate;
        }
        else {
          this._Subscription.TerminationDate = formatDate(this._Subscription.TerminationDate.jsdate);
        }


        if (this._Subscription.Module == 'Accounting') {
          if (this.CompareDate != null) {
            var Transactionsdate = this.CompareDate.split('~');

            //if (formatDate(this.CompareDate) < this._Subscription.DataStartDate) {
            //  this.toastr.error("Transactions have been posted for " + formatDateWithtime(this.CompareDate) + ". Please enter Data Start Date less than or equal to this transaction date");
            //  this.loading = false;
            //  return;
            //}


            if (Transactionsdate[1] == 'MasterData') {
              if (formatDate(Transactionsdate[0]) < this._Subscription.DataStartDate) {
                this.toastr.error("Transactions have been posted for " + formatDateWithtime(Transactionsdate[0]) + ". Please enter Data Start Date less than or equal to this transaction date");
                this.loading = false;
                return;
              }
            }
            if (Transactionsdate[1] == 'subscription') {
              if (formatDate(Transactionsdate[0]) < this._Subscription.DataStartDate) {
                this.toastr.error("Subscription has been created for " + formatDateWithtime(Transactionsdate[0]) + ". Please enter Data Start Date less than or equal to this subscription start date");
                this.loading = false;
                return;
              }
            }



          }
        }

        //if (this._Subscription.subscriptionId != "") {
        //  //Below changes are update code
        //  this.ValidationSubscriptionStartDate();

        //  if (this._Subscription.BookingDate != "") {

        //    var date = new Date(this._Subscription.BookingDate);
        //    this._Subscription.BookingDate = new Date(date.getFullYear(), date.getMonth(), 1);
        //    this._Subscription.BookingDate = formatDate(this._Subscription.BookingDate);

        //    if (this._Subscription.BookingDate != "" && this.QuerySDate != "") {

        //      if (this._Subscription.BookingDate > this.QuerySDate) {
        //        this.toastr.error("Booking date should be less than or equal to Start date.");
        //        this.loading = false;
        //        return false;
        //      }
        //      else if (this._Subscription.BookingDate != undefined && this._Subscription.EffectiveStartDate != "") {
        //        if (this._Subscription.BookingDate > this.QueryEffDate) {
        //          this.toastr.error("Booking date should be less than or equal to Effective Start date.");
        //          this.loading = false;
        //          return false;
        //        }
        //      }

        //    }
        //  }



        //}
        //else {
        //  // 
        //  this.QueryStartDate = this._Subscription.StartDate;

        //  if (this._Subscription.BookingDate != "") {

        //    var date = new Date(this._Subscription.BookingDate);
        //    this._Subscription.BookingDate = new Date(date.getFullYear(), date.getMonth(), 1);
        //    this._Subscription.BookingDate = formatDate(this._Subscription.BookingDate);

        //    if (this._Subscription.BookingDate != "" && this._Subscription.StartDate != "") {

        //      if (this._Subscription.BookingDate > this._Subscription.StartDate) {
        //        this.toastr.error("Booking date should be less than or equal to Start date.");
        //        this.loading = false;
        //        return;
        //      }
        //      else if (this._Subscription.BookingDate != undefined && this._Subscription.EffectiveStartDate != "") {
        //        if (this._Subscription.BookingDate > this._Subscription.EffectiveStartDate) {
        //          this.toastr.error("Booking date should be less than or equal to Effective Start date.");
        //          this.loading = false;
        //          return;
        //        }
        //      }

        //    }
        //  }
        //}


        //if (this._Subscription.BookingDate != "" && this._Subscription.StartDate != "") {

        //  if (this._Subscription.BookingDate >= this._Subscription.StartDate) {
        //    if (this._Subscription.BookingDate > this._Subscription.StartDate) {
        //      this.toastr.error("Booking date should be less than Billing Start date.");
        //    }
        //    else {
        //      this.toastr.error("Billing Start date should be more than Booking date.");
        //    }
        //    this.loading = false;
        //    return;
        //  }
        //  else if (this._Subscription.BookingDate != "" && this._Subscription.EffectiveStartDate != "") {

        //    if (this._Subscription.BookingDate >= this._Subscription.EffectiveStartDate) {
        //      if (this._Subscription.BookingDate > this._Subscription.EffectiveStartDate) {
        //        this.toastr.error("Booking date should be less than Effective Start date.");
        //      }
        //      else {
        //        this.toastr.error("Effective Start date should be more than Booking date.");
        //      }
        //      this.loading = false;
        //      return;
        //    }

        //  }
        //}

        this.QueryStartDate = this._Subscription.PayPeriodStartDate;
        if (this._Subscription.Module == 'Labor Management') {
          if (this._Subscription.PayPeriodFrequency == 'weekly') {
            var VStartdate = new Date(this.QueryStartDate);
            VStartdate.setDate(VStartdate.getDate() + 6);
            if (formatDate(VStartdate) > this._Subscription.StartPayDate) {
              this.toastr.error("Pay Date should be greater than or equal to Pay Period End Date");
              this.loading = false;
              return;
            }
          }
        }

        if (this._Subscription.Module == 'Labor Management') {
          if (this._Subscription.PayPeriodFrequency == 'bi-weekly') {
            //   var VStartdate = new Date(this.QueryStartDate);
            var VStartdate = new Date(this._Subscription.PayPeriodStartDate);
            VStartdate.setDate(VStartdate.getDate() + 13);
            if (formatDate(VStartdate) > this._Subscription.StartPayDate) {
              this.toastr.error("Pay Date should be greater than or equal to Pay Period End Date");
              this.loading = false;
              return;
            }
          }
        }



        if (this._Subscription.Module == 'Labor Management' && this._Subscription.PayPeriodFrequency.toUpperCase() == "WEEKLY") {
          // this.QueryPayrollStartDate = new Date(this.QueryPayrollStartDate);
          var strDate = formatDate(VStartdate);
          this.QueryPayrollStartDate = new Date(strDate);
          var weeklyDate = new Date(this.QueryWeeklyDate);
          // weeklyDate.setDate(weeklyDate.getDate() + 10);
          weeklyDate.setDate(this.QueryPayrollStartDate + 10);

          if ((this._Subscription.PayrollProcessingDate < formatDate(this.QueryPayrollStartDate)) || (this._Subscription.PayrollProcessingDate > formatDate(weeklyDate))) {
            this.toastr.error("Payroll Processing Date Should be greater than or equal to Pay Period end date and less than 10 days after the Pay Period end date.");
            this.loading = false;
            return;
          }
        }

        if (this._Subscription.Module == 'Labor Management' && this._Subscription.PayPeriodFrequency.toUpperCase() == "BI-WEEKLY") {
          //    this.QueryPayrollStartDate = new Date(this.QueryPayrollStartDate);
          var strDate = formatDate(VStartdate);
          this.QueryPayrollStartDate = new Date(strDate);
          var weeklyDate = new Date(this.QueryWeeklyDate);
          //  weeklyDate.setDate(weeklyDate.getDate() + 10);
          weeklyDate.setDate(this.QueryPayrollStartDate + 10);
          if ((this._Subscription.PayrollProcessingDate < formatDate(this.QueryPayrollStartDate)) || (this._Subscription.PayrollProcessingDate > formatDate(weeklyDate))) {
            this.toastr.error("Payroll Processing Date Should be greater than or equal to Pay Period end date and less than 10 days after the Pay Period end date.");
            this.loading = false;
            return;
          }
        }

        if (this._Subscription.Module == 'Labor Management' && this._Subscription.PayPeriodFrequency.toUpperCase() == "-1") {
          this.isValidFormSubmitted = true;
          this.loading = false;
          return;
        }



        this._Subscription.UserName = sessionStorage.getItem('UserName');
        if (this._Subscription.Adjustment != false) {
          if (this._Subscription.Adjustment == undefined) {
            this._Subscription.Adjustment = false;
          }
        }


        if (this._Subscription.AutoImport == true) {
          this._Subscription.AutoImport = true;
        }
        else {
          this._Subscription.AutoImport = false;
        }
        //if (this._Subscription.AutoImport != false) {
        //  if (this._Subscription.AutoImport == undefined) {
        //    this._Subscription.AutoImport = false;
        //  }
        //}


        if (this._Subscription.IsFacialRecogEnable != false) {
          if (this._Subscription.IsFacialRecogEnable == undefined) {
            this._Subscription.IsFacialRecogEnable = false;
          }
        }

        if (this._Subscription.IsTipEnable != false) {
          if (this._Subscription.IsTipEnable == undefined) {
            this._Subscription.IsTipEnable = false;
          }
        }
        if (this._Subscription.IsSmileID != false) {
          if (this._Subscription.IsSmileID == undefined) {
            this._Subscription.IsSmileID = false;
          }
        }

        this._Subscription.PassFailThreshold = this._Subscription.PassFailThreshold;

        if (this._Subscription.IsPwdRequiredForTC != false) {
          if (this._Subscription.IsPwdRequiredForTC == undefined) {
            this._Subscription.IsPwdRequiredForTC = false;
          }
        }



        if (this._Subscription.Payroll != false) {
          if (this._Subscription.Payroll == undefined) {
            this._Subscription.Payroll = false;
          }
        }

        if (this._Subscription.Module == 'Labor Management') {
          if (!parseInt(this._Subscription.PassFailThreshold)) {
            this.toastr.error("Facial Pass/Fail Threshold should be numeric.");
            this.loading = false;
            return;
          }
          if (this._Subscription.PassFailThreshold.indexOf(".") != -1) {
            this.toastr.error("Facial Pass/Fail Threshold should be numeric.");
            this.loading = false;
            return;
          }


          if (this._Subscription.IsPwdRequiredForTC == false && this._Subscription.IsFacialRecogEnable == false) {
            this.toastr.error("Either require password or Enable facial recognition must be checked.");
            this.loading = false;
            return;
          }
        }



        if (this._Subscription.Module == 'Labor Management' && this.type == "Edit") {

          this.OldData = JSON.parse(sessionStorage.getItem('data'));
          var oldFrequency = this.OldData[0].payPeriodFrequency;
          var oldDate = formatDate(this.OldData[0].payPeriodStartDate);
          if (this.oldpayPeriodFrequency && this.oldpayPeriodFrequency != oldFrequency || this.payPeriodStartCheck && this.payPeriodStartCheck != oldDate) {
            if (confirm("Changing this setting will cause historical labor reporting to display different values. Financials will remain unaffected. Please make sure that the enterprise is aware of this change.")) {
              console.log(this._Subscription);
              this._Subscriptions.SaveSubscriptionDetails(this._Subscription).subscribe(res => {
                var data = res;
                console.log(data);

                this.loading = false;
                if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
                  this.toastr.success(data.message, ' SubscriptionID:' + data.subscriptionId, {
                    allowHtml: true
                  });
                  this._Subscription.subscriptionId = data.subscriptionId;
                  this.querymodule = this._Subscription.Module;
                  this.Editdata();
                  this.GetSubscriptionchangeLog();
                  if (this.type == 'New') {
                    this.getSubscriptionDetails();
                  }
                  this.type = 'Edit';

                  if (this._Subscription.ImpCompletionDate == "") {
                    this._Subscription.ImpCompletionDate = "";
                  }
                  //form.reset();

                }
                else {
                  this.toastr.error(data.message);
                }

              });
            } else {
              this.loading = false;
            }
          }
          else {

            console.log(this._Subscription);
            this._Subscriptions.SaveSubscriptionDetails(this._Subscription).subscribe(res => {
              var data = res;
              console.log(data);

              this.loading = false;
              if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
                this.toastr.success(data.message, ' SubscriptionID:' + data.subscriptionId, {
                  allowHtml: true
                });
                this._Subscription.subscriptionId = data.subscriptionId;
                this.querymodule = this._Subscription.Module;
                this.Editdata();
                this.GetSubscriptionchangeLog();
                if (this.type == 'New') {
                  this.getSubscriptionDetails();
                }
                this.type = 'Edit';

                if (this._Subscription.ImpCompletionDate == "") {
                  this._Subscription.ImpCompletionDate = "";
                }
                //form.reset();

              }
              else {
                this.toastr.error(data.message);
              }
            });
          }

        }

        if (this._Subscription.Module != 'Labor Management') {
          console.log(this._Subscription);
          this._Subscription.subscriptionServices = this.subscriptionServiceData;
          this._Subscription.subscriptionServices = this._Subscription.subscriptionServices.map((data: any) => {
            data.startDate = data.startDate ? (data.startDate.formatted ? data.startDate.formatted : this.formatDateToMMDDYYYY(data.startDate.jsdate || data.startDate)) : data.startDate;
            data.endDate = data.endDate ? (data.endDate.formatted ? data.endDate.formatted : this.formatDateToMMDDYYYY(data.endDate.jsdate || data.endDate)) : data.endDate;
            return data
          });

          if (!this.validateSubscriptionServicesData()) {
            this.loading = false;
            return;
          };


          this._Subscriptions.SaveSubscriptionDetails(this._Subscription).subscribe(res => {
            var data = res;
            console.log(data);

            this.loading = false;
            if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
              this.toastr.success(data.message, ' SubscriptionID:' + data.subscriptionId, {
                allowHtml: true
              });
              this._Subscription.subscriptionId = data.subscriptionId;
              this.querymodule = this._Subscription.Module;
              this.Editdata();
              this.GetSubscriptionchangeLog();
              this.GetSubscriptionServices();
              if (this.type == 'New') {
                this.getSubscriptionDetails();
              }
              this.type = 'Edit';

              if (this._Subscription.ImpCompletionDate == "") {
                this._Subscription.ImpCompletionDate = "";
              }
              //form.reset();

            }
            else {
              this.toastr.error(data.message);
            }
          });
        }
        else {
          if (this.type == "New" && this._Subscription.Module == 'Labor Management') {
            console.log(this._Subscription);
            this._Subscriptions.SaveSubscriptionDetails(this._Subscription).subscribe(res => {
              var data = res;
              console.log(data);

              this.loading = false;
              if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
                this.toastr.success(data.message, ' SubscriptionID:' + data.subscriptionId, {
                  allowHtml: true
                });
                this._Subscription.subscriptionId = data.subscriptionId;
                this.querymodule = this._Subscription.Module;
                this.Editdata();
                this.GetSubscriptionchangeLog();
                this.GetSubscriptionServices();
                if (this.type == 'New') {
                  this.getSubscriptionDetails();
                }
                this.type = 'Edit';

                if (this._Subscription.ImpCompletionDate == "") {
                  this._Subscription.ImpCompletionDate = "";
                }
                //form.reset();

              }
              else {
                this.toastr.error(data.message);
              }
            });
          }
        }
      }
      else {
        this.loading = false;
        //this.toastr.error("Given Entity does not have Labor Management.Please add Labour Management Subscription first to add Payroll Services.");
        if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
          this.toastr.error("Payroll - CheckHQ subscription cannot be added as Labor Management module is not subscribed yet.");
        }
        else {
          this.toastr.error("Payroll Service subscription cannot be added as Labor Management module is not subscribed yet.");
        }
      }
    }
    else {
      this.isValidFormSubmitted = true;
    }

  }

  public keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public strimdata(val: string) {
    if (val != undefined) {
      return val.trim();
    }
  }
  //uploadFileToActivity() {
  //  this._Subscriptions.postFile(this.fileToUpload).subscribe(data => {
  //    this.toastr.success("FileUploaded");
  //  }, error => {
  //    console.log(error);
  //  });
  //}
  AddTable() {
    this.AddTablearray.push('');
  }
  public Editdata() {
    //
    this._Subscriptions.GetEditSubSearchResult(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString(), this.querymodule, 'COMPLETE').subscribe(res => {
      var data = res;
      this.fillEditdata(data);

    });
  }

  public GetSubscriptionchangeLog() {
    this._Subscriptions.GetSubscriptionchangeLog(this._Subscription.subscriptionId).subscribe(res => {
      this.SubscriptionChangeLog = res;
    });
  }

  ShowLog() {
    this.modelChangeLog = "block";
  }


  fillEditdata(data: any) {

    //console.log(data);
    sessionStorage.setItem('data', JSON.stringify(data))

    this.entityStatus = data[0].entityStatus;
    this._Subscription.ImplementationStatus = data[0].implementationStatus;
    this._Subscription.RenewalAmount = data[0].renewalAmount;
    if (data[0].bookingDate == null) {
      this._Subscription.BookingDate = "";
    }
    else {
      this._Subscription.BookingDate = {
        jsdate: new Date(data[0].bookingDate)
      };
    }
    if (data[0].startDate == "null") {
      this._Subscription.StartDate = "";
    }
    else {
      this._Subscription.StartDate = {
        jsdate: new Date(data[0].startDate)
      };
    }
    if (data[0].effecStartDate == "null") {
      this._Subscription.EffectiveStartDate = "";
    }
    else {
      this._Subscription.EffectiveStartDate = {
        jsdate: new Date(data[0].effecStartDate)
      };
    }
    // this._Subscription.BookingDate = data[0].BookingDate;
    this._Subscription.Status = data[0].status;
    this._Subscription.subscriptionId = data[0].subscriptionId;
    this.localSubscriptionID = data[0].subscriptionId;
    this._Subscription.subscriptionType = data[0].subscriptionType;
    this._Subscription.Trainer = data[0].trainer;
    this._Subscription.SubId = data[0].id;
    this._Subscription.PassFailThreshold = data[0].passFailThreshold;
    if (data[0].adjustment == "true") {
      this._Subscription.Adjustment = data[0].adjustment;
    }
    if (data[0].autoImport == "true") {
      this._Subscription.AutoImport = true;
      //data[0].autoImport;
    }
    if (data[0].isFacialRecogEnable == "true") {
      this._Subscription.IsFacialRecogEnable = data[0].isFacialRecogEnable;
    }
    if (data[0].isTips == "true") {
      this._Subscription.IsTipEnable = data[0].isTips;
    }
    if (data[0].isSmileID == "true") {
      this._Subscription.IsSmileID = data[0].isSmileID;
    }
    if (data[0].isPwdRequiredForTC == "true") {
      this._Subscription.IsPwdRequiredForTC = data[0].isPwdRequiredForTC;
    }
    if (data[0].payroll == "true") {
      this._Subscription.Payroll = data[0].payroll;
    }
    this._Subscription.PayrollProcessorEmail = data[0].payrollProcessorEmail;
    this._Subscription.PayPeriodFrequency = data[0].payPeriodFrequency;
    if (data[0].payPeriodStartDate == "null") {
      this._Subscription.PayPeriodStartDate = "";
    }
    else {
      this._Subscription.PayPeriodStartDate = {
        jsdate: new Date(data[0].payPeriodStartDate)
      };

    }
    if (data[0].startPayDate == "null") {
      this._Subscription.StartPayDate = "";
    }
    else {
      this._Subscription.StartPayDate = {
        jsdate: new Date(data[0].startPayDate)
      };

    }


    this._Subscription.PayrollExportType = data[0].payrollExportType;
    //this._Subscription.PayrollProcessingDate = data[0].payrollProcessingDate;
    if (data[0].fileName != null) {
      this.Attachtext = data[0].fileName;
    }
    this._Subscription.OvertimeRules = data[0].overtimeRules;
    //this._Subscription.MaxWeeklyHours = data[0].maxWeeklyHours;
    //this._Subscription.MaxDailyHours = data[0].maxDailyHours
    this._Subscription.TimeClockCount = data[0].timeclockcount;
    //this._Subscription.PassFailThreshold = data[0].PassFailThreshold;
    this._Subscription.TotalEmployees = data[0].totalEmployees;
    
    // Set TotalEmployees in SignatoryForm if module is PayrollCheckHQ
    if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ && this._Subscription.TotalEmployees) {
      setTimeout(() => {
        if (this.sigForm) {
          this.sigForm.setTotalEmployees(this._Subscription.TotalEmployees);
        }
      }, 0);
    }
    
    if (data[0].payrollProcessingdate == null) {
      this._Subscription.PayrollProcessingDate = "";
    }
    else {
      this._Subscription.PayrollProcessingDate = {
        jsdate: new Date(data[0].payrollProcessingdate)
      };
    }
    if (data[0].dataStartdate == "null") {
      this._Subscription.DataStartDate = "";
    }
    else {
      this._Subscription.DataStartDate = { jsdate: new Date(data[0].dataStartdate) };
    }
    if (data[0].fullSubscriptionStartDate == "null") {
      this._Subscription.FullsubscriptionStartDate = "";
    }
    else {
      this._Subscription.FullsubscriptionStartDate = { jsdate: new Date(data[0].fullSubscriptionStartDate) };
    }
    if (data[0].startDate == "null") {
      this._Subscription.StartDate = "";
    }
    else {
      this._Subscription.StartDate = { jsdate: new Date(data[0].startDate) };
    }

    // if (data[0].status == "Inactive") {
    if (data[0].terminationdate == null) {
      this._Subscription.TerminationDate = "";
    }
    else {
      this._Subscription.TerminationDate = { jsdate: new Date(data[0].terminationdate) };
    }
    //}
    this._Subscription.ReasonForTermination = data[0].reasonfortermination;
    this._Subscription.TerminationNotes = data[0].terminationnotes;
    this._Subscription.Module = data[0].module;
    // Load existing signatory if module is PayrollCheckHQ
    if (this._Subscription.Module == SubscriptionModule.PayrollCheckHQ) {
      this.LoadSignatory();
    }
    this._Subscription.CC1NAME = data[0].cC1NAME;
    this._Subscription.CC1TITLE = data[0].cC1TITLE;
    this._Subscription.CC1EMAIL = data[0].cC1EMAIL;
    this._Subscription.CC1PHONE = data[0].cC1PHONE;
    this._Subscription.CC2NAME = data[0].cC2NAME;
    this._Subscription.CC2TITLE = data[0].cC2TITLE;
    this._Subscription.CC2EMAIL = data[0].cC2EMAIL;
    this._Subscription.CC2PHONE = data[0].cC2PHONE;
    this._Subscription.HC1NAME = data[0].hC1NAME;
    this._Subscription.HC1TITLE = data[0].hC1TITLE;
    this._Subscription.HC1EMAIL = data[0].hC1EMAIL;
    this._Subscription.HC1PHONE = data[0].hC1PHONE;
    this._Subscription.HC2NAME = data[0].hC2NAME;
    this._Subscription.HC2TITLE = data[0].hC2TITLE;
    this._Subscription.HC2EMAIL = data[0].hC2EMAIL;
    this._Subscription.HC2PHONE = data[0].hC2PHONE;
    if (data[0].implementationCompletionDate == null) {
      this._Subscription.ImpCompletionDate = "";

    }
    else {
      this._Subscription.ImpCompletionDate = { jsdate: new Date(data[0].implementationCompletionDate) };
      this.checkdate = '0';
    }
    this.SetdOTW1(this._Subscription.StartPayDate);
    this.SetdOTW(this._Subscription.PayPeriodStartDate);
    this.SetdOTW2(this._Subscription.PayrollProcessingDate);
    this.GetSubscriptionchangeLog();
    console.log(this._Subscription.ImpCompletionDate, this._Subscription.BookingDate);
  }


  OpenSubscription() {
    this.ModelAddSubscription = "block";
    this.SubscriptionDet = {};
    this.SubDet = {};
    this._Subscription.SubDetails = [];
    //this.Editdata();
    this.getSubscriptionDetails();
    this.isValidSubscription = false;
    this.btndisable = false;
  }
  CloseSubscription() {
    this.ModelAddSubscription = "none";

  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  CheckChangeStatus(int: number, SubsStatus: string, ValType: string) {

    this._Subscription.SubDetails[int].ischange = 'Yes';
    var data = this._Subscription.SubDetails.indexOf()

    var len = this._Subscription.SubDetails.length;
    if (this._Subscription.SubDetails[len - 1].renewalAmount == '' && this._Subscription.SubDetails[len - 1].status == 'Select' && this._Subscription.SubDetails[len - 1].startDate == "" && this._Subscription.SubDetails[len - 1].effecStartDate == "") {
      len = len - 1;
    }

    if (len - 1 == int) {
      //if (this._Subscription.SubDetails.==int){
      if (this._Subscription.SubDetails[len - 1].status == "Inactive") {
        if (ValType == 'Status') {
          this.SubsDetStatus = SubsStatus;
        }
      }
      else {
        this.SubsDetStatus = SubsStatus;
      }
    }





    if (ValType == 'Status' && SubsStatus == 'Active') {
      //this._Subscription.TerminationDate = "";
      //this._Subscription.ReasonForTermination = "";
      //this._Subscription.TerminationNotes = "";

    }

    /*
    if (int > 0) {
      if (this._Subscription.SubDetails[int].status == this._Subscription.SubDetails[int-1].status) {
        if (this._Subscription.SubDetails[int].status == 'Inactive') {
          this._Subscription.SubDetails[int].status = 'Active';
          this.toastr.error("Subscription already terminated");         
          return;
        }
      }
    }*/

  }

  CancelSubscriptionPage() {
    if (this.ParentPage == "Subscription") {
      this.router.navigate(['/Subscription'])
    }
    else if (this.ParentPage == "SubscriptionDetails") {
      this.router.navigate(['/Subscription'])
    }
    else {
      this.router.navigate(['/CreateEntity', {
        TenantID: btoa(JSON.stringify(this._Subscription.TenantId)),
        EntityID: btoa(JSON.stringify(this._Subscription.HotelId)),
        pageName: btoa(JSON.stringify('SubscriptionDetail')),
        OrgCode: btoa(JSON.stringify(this._Subscription.OrganizationCode))
      }]);

    }

    //this._Subscription.Status = this._lastSubStatus;
  }
  CloseChangeLog() {
    this.modelChangeLog = "none";
  }


  //DownloadFile() {
  //  
  //  this._OrganizationSer.GetEntitiesExportTemplate().subscribe(res => {

  //    importedSaveAs(res, "EntityImportTemplate.xlsx");

  //  })
  //}

  fileChange(event: any) {


    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.File = fileList[0];

    }
  }

  ImportFile(event: any) {


    if (this.Attachtext == "Attach acceptance document") {
      this.loading = true;
      let fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        this.File = fileList[0];
        let file: File = this.File;
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        let headers = new Headers();
        let param = {
          "UserName": JSON.stringify(sessionStorage.getItem('UserName')),
          "HotelId": JSON.stringify(this._Subscription.HotelId),
          "Tenantid": JSON.stringify(this._Subscription.TenantId),
          "SubscriptionId": JSON.stringify(this._Subscription.subscriptionId)
        };
        let options = new RequestOptions({ headers: headers, params: param });
        let apiUrl1 = "api/Subscription/UploadFile";
        this.http.post(apiUrl1, formData, options)
          .map(res => res)
          .catch(error => Observable.throw(error))
          .subscribe(
            data => {

              this.Attachtext = data._body;
              this.loading = false;
            }
          )
      }
    }

  }

  DownloadFile() {
    if (this.Attachtext != "Attach acceptance document") {
      this.loading = true;
      this._Subscriptions.GetSubscriptionExportTemplate(this._Subscription.subscriptionId, this.Attachtext).subscribe(res => {

        let data = res.blob();
        importedSaveAs(data);
        this.loading = false;
      })
    }
    else { }
  }

  closefile() {
    this._Subscriptions.DeleteFile(this._Subscription.subscriptionId).subscribe();
    this.Attachtext = "Attach acceptance document";
  }

  FacialRecogChange() {
    console.log(this._Subscription.IsFacialRecogEnable);
    if (!this._Subscription.IsFacialRecogEnable) {
      this._Subscription.IsSmileID = false;

    }
  }


  ClearTimeClockDevice() {
    this._TimeClockDeviceDetails.uniqueNo = '0';
    this._TimeClockDeviceDetails.DefaultLanguage = 'English-(en-us)';
    this._TimeClockDeviceDetails.MachinId = '';
    this._TimeClockDeviceDetails.Notes = '';
    this._TimeClockDeviceDetails.SaveButtonCaption = 'Save & Close';
  }
  OpenModelTimeClockDevice() {
    this.ClearTimeClockDevice();
    this.ModelTimeClockDevice = "block";
  }
  CloseModelTimeClockDevice() {
    this.ClearTimeClockDevice();
    this.ModelTimeClockDevice = "none";

  }

  public getMachineIdDetail() {
    //
    this._Subscriptions.GetMachineIDDetail(this._Subscription.TenantId.toString(), this._Subscription.HotelId.toString()).subscribe(res => {
      this.GetModelTimeClockDevice = res;
    });
  }

  public EnableDisableDevice(uniqueNo, EnableDisable) {
    // 
    if (EnableDisable == null) { EnableDisable = 'false'; }
    let x = EnableDisable;
    if (x == 'false') { EnableDisable = 'true' };
    if (x == 'true') { EnableDisable = 'false' };
    this._Subscriptions.EnableDisableMachineIDDetail(uniqueNo, EnableDisable).subscribe(res => {
      //this.toastr.error("Durga " + res);
      if (res != '') { this.toastr.error(res); }
      else {
        if (EnableDisable == 'true') { this.toastr.success("Time Clock Device ID Enabled successfully."); }
        else { this.toastr.error("Time Clock Device ID Disabled successfully."); }
      }
      this.getMachineIdDetail();
    });
  }

  public DeleteDevice(uniqueNo) {
    // 
    if (confirm("Are you sure to delete this Device ID ?")) {
      this._Subscriptions.DeleteMachineIDDetail(uniqueNo).subscribe(res => {
        this.toastr.success("Time Clock Device ID deleted successfully.");
        this.getMachineIdDetail();
      });
    }
  }

  public EditDevice(uniqueNo, machinId, defaultLanguage, notes) {
    this._TimeClockDeviceDetails.uniqueNo = uniqueNo;
    this._TimeClockDeviceDetails.MachinId = machinId;
    this._TimeClockDeviceDetails.DefaultLanguage = defaultLanguage;
    this._TimeClockDeviceDetails.Notes = notes;
    this._TimeClockDeviceDetails.SaveButtonCaption = 'Update & Close';
    this.ModelTimeClockDevice = "block";
  }

  public SaveLaborTimeClockDeviceDetails() {
    this._Subscriptions.SaveLaborTimeClockDeviceDetails(
      this._Subscription.HotelId.toString(), this._Subscription.TenantId.toString(),
      sessionStorage.getItem('UserName').toString(),
      this._TimeClockDeviceDetails.uniqueNo.toString(),
      this._TimeClockDeviceDetails.MachinId.toString(),
      this._TimeClockDeviceDetails.DefaultLanguage.toString(),
      this._TimeClockDeviceDetails.Notes.toString()).subscribe(res => {
        if (res != '') { this.toastr.error(res); }
        else {
          this.ModelTimeClockDevice = "none";
          if (this._TimeClockDeviceDetails.uniqueNo.toString() == '0') { this.toastr.success("Time Clock Device ID Saved successfully."); }
          else { this.toastr.success("Time Clock Device ID Updated successfully."); }
          this.ClearTimeClockDevice();
          this.getMachineIdDetail();
        }
      });
  }
}

export class Userdetails {
  constructor(
    public useruniqueNo: string,
    public Status: string,
  ) { }
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}

function formatDateWithtime(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [month, day, year].join('/');
}



// WEBPACK FOOTER //
// ./src/app/Subscription/SubscriptionDetails.component.ts